import { FunctionComponent } from 'react';
import { toString } from 'es-toolkit/compat';

import { ComponentRadiobutton } from '@tock/shared/inputs/ComponentRadiobutton';
import { RadiobuttonGroup } from '@tock/shared/inputs';
import { consumer } from '@tock/coretypes';
import QuizImageDisplay from './QuizImageDisplay';

export interface Props {
  question: consumer.IPatronQuizQuestion;
  selectedOptionId?: number;
  onAnswer(optionId: number[]): void;
}

const ImageSelectQuizQuestion: FunctionComponent<Props> = ({
  question,
  selectedOptionId,
  onAnswer,
}) => {
  return (
    <div className="QuizModal-ImageSelect-questionOuterBox-wrapper">
      <RadiobuttonGroup className="RadioButtons--horizontal">
        {question.option?.map((option) => {
          if (!option.id) {
            return;
          }
          const isSelected = selectedOptionId === option.id;
          return (
            <ComponentRadiobutton
              key={`ImageSelect-question-${toString(option.id)}`}
              name={toString(question.id) || undefined}
              onChange={() => option.id && onAnswer([option.id])}
              checked={isSelected}
              component={option && <QuizImageDisplay option={option} />}
              label={option.displayText || ''}
              className="QuizModal-ImageSelect-questionOuterBox"
            />
          );
        })}
      </RadiobuttonGroup>
    </div>
  );
};

export default ImageSelectQuizQuestion;
